import React from "react";
import { Grid, TableCell, Typography } from "@mui/material";
import { RoundResult, RoundType } from "../../interfaces/ICompetitions";

interface RoundTableRowProps {
  round: RoundResult;
  competitionId?: string;
  categoryId?: string;
}

function RoundTableRow({ round }: RoundTableRowProps) {
  const getRoundTypeLabel = (type: RoundType): string => {
    return type === RoundType.FINAL ? "Finał" : "Eliminacje";
  };

  return (
    <TableCell sx={{ py: 1.5 }}>
      <Grid container spacing={1}>
        <Grid item xs={12} sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography
            variant="subtitle1"
            component="div"
            color="primary"
            sx={{
              fontWeight: 600,
              fontSize: { xs: "0.875rem", sm: "0.9375rem" },
              lineHeight: 1.3,
              wordBreak: "break-word",
              mb: { xs: 0.5, sm: 0 },
            }}
          >
            {round.name}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontSize: { xs: "0.75rem", sm: "0.75rem" },
            }}
          >
            {getRoundTypeLabel(round.type)}
          </Typography>
        </Grid>
      </Grid>
    </TableCell>
  );
}

export default React.memo(RoundTableRow);
